// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"login_loginWrapper__3plbJ","logo":"login_logo__3wGMJ"};